import { TireSeason, type InspectionSessionRecord } from '@navio/nsdk';
import { INSPECTION_WHEELS, resolveObservations, type WheelField } from 'noddi-util';

export { treadMeasurementItem } from 'noddi-util';

export type WheelMeasurementValue = {
  measuredAt: string;
  value: { value: number; unit: string };
};

export type SeasonMeasurementMap = Partial<Record<WheelField, WheelMeasurementValue>>;

export type BookingItemMeasurementsView = {
  summer: SeasonMeasurementMap;
  winter: SeasonMeasurementMap;
  skipReason: string | null;
};

/** Summer and winter tread from the shared resolver. A later skip does not replace a usable reading. */
export const mapInspectionSessionsToMeasurements = (
  sessions: InspectionSessionRecord[]
): BookingItemMeasurementsView => {
  const { treadsBySeason, skipReason } = resolveObservations(sessions);
  const toMap = (season: TireSeason): SeasonMeasurementMap => {
    const readings = treadsBySeason[season];
    const map: SeasonMeasurementMap = {};
    if (!readings) {
      return map;
    }
    for (const { field } of INSPECTION_WHEELS) {
      const tread = readings[field];
      if (tread) {
        map[field] = { measuredAt: tread.measuredAt, value: { value: tread.value, unit: tread.unit } };
      }
    }
    return map;
  };

  return { summer: toMap(TireSeason.SUMMER), winter: toMap(TireSeason.WINTER), skipReason };
};
